// SEO switch (Alex 2026-07-22): moved from hash mode to history mode so Google can
// index /marketplace/listing/:id etc. Old #/foo URLs shared on WhatsApp still work —
// see the client-side redirector in main.js that strips the # on load.
import {createWebHistory, createRouter} from "vue-router";
import { executeJson, flocker } from "@/api";

// ===== AUTH =====
import Login from "@/components/Login.vue";
import Register from "@/components/Register.vue";
import ResetPasswordPage from "@/components/ResetPasswordPage.vue";

// ===== DASHBOARD =====
import Dashboard from "@/components/Dashboard.vue";
import DevelopersHome from "@/components/flockr-developers/DevelopersHome.vue";
import DeveloperAppDetail from "@/components/flockr-developers/DeveloperAppDetail.vue";
import DevelopersDocs from "@/components/flockr-developers/DevelopersDocs.vue";

// ===== LANDING =====
import LandingPage from "@/components/flockr-marketplace/LandingPage.vue";

// ===== MARKETPLACE - BROWSING & DISCOVERY =====
import MarketplaceHome from "@/components/flockr-marketplace/MarketplaceHome.vue";
import ListingSearchResults from "@/components/flockr-marketplace/ListingSearchResults.vue";
import ListingDetail from "@/components/flockr-marketplace/ListingDetail.vue";
import SellerProfile from "@/components/flockr-marketplace/SellerProfile.vue";
import MyReferrals from "@/components/flockr-users/MyReferrals.vue";

// ===== BILLS (Proforma invoice · Alex 2026-07-21) =====
import CreateBill from "@/components/flockr-bills/CreateBill.vue";
import MyBills from "@/components/flockr-bills/MyBills.vue";
import BillsInbox from "@/components/flockr-bills/BillsInbox.vue";
import BillView from "@/components/flockr-bills/BillView.vue";
import CreditPassport from "@/components/flockr-credit/CreditPassport.vue";
import CreditStatementPrint from "@/components/flockr-credit/CreditStatementPrint.vue";
import PublicCreditPassport from "@/components/flockr-credit/PublicCreditPassport.vue";
import CategoryBrowse from "@/components/flockr-marketplace/CategoryBrowse.vue";
import SellerVerificationPage from "@/components/flockr-marketplace/SellerVerificationPage.vue";



// ===== MARKETPLACE - SELLING / LISTING MANAGEMENT =====
import CreateListingPage from "@/components/flockr-marketplace/CreateListingPage.vue";
import EditListingPage from "@/components/flockr-marketplace/EditListingPage.vue";
import MyListingsPage from "@/components/flockr-marketplace/MyListingsPage.vue";
import ListingPerformance from "@/components/flockr-marketplace/ListingPerformance.vue";

// ===== MARKETPLACE - BUYER ACTIONS =====
import SavedListingsPage from "@/components/flockr-marketplace/SavedListingsPage.vue";
import SavedSearchesPage from "@/components/flockr-marketplace/SavedSearchesPage.vue";
import MakeOfferPage from "@/components/flockr-marketplace/MakeOfferPage.vue";
import MyOffersPage from "@/components/flockr-marketplace/MyOffersPage.vue";

// ===== MARKETPLACE - AGGREGATOR / BUY REQUESTS =====
import BuyRequestsBoard from "@/components/flockr-marketplace/BuyRequestsBoard.vue";
import CreateBuyRequest from "@/components/flockr-marketplace/CreateBuyRequest.vue";
import BuyRequestDetail from "@/components/flockr-marketplace/BuyRequestDetail.vue";
import MyBuyRequests from "@/components/flockr-marketplace/MyBuyRequests.vue";
import SupplierNetworkPage from "@/components/flockr-marketplace/SupplierNetworkPage.vue";
import Cart from "@/components/flockr-marketplace/Cart.vue";
import CartCheckout from "@/components/flockr-marketplace/CartCheckout.vue";


// ===== ORDERS & TRANSACTIONS =====
import CheckoutPage from "@/components/flockr-orders/CheckoutPage.vue";
import OrdersPage from "@/components/flockr-orders/OrdersPage.vue";
import OrderDetail from "@/components/flockr-orders/OrderDetail.vue";
import EscrowDashboard from "@/components/flockr-orders/EscrowDashboard.vue";
import WalletPage from "@/components/flockr-orders/WalletPage.vue";
import DisputePage from "@/components/flockr-orders/DisputePage.vue";
import ReviewsPage from "@/components/flockr-orders/ReviewsPage.vue";

// ===== MESSAGING & NOTIFICATIONS =====
import MessagesInbox from "@/components/flockr-messaging/MessagesInbox.vue";
import ChatThread from "@/components/flockr-messaging/ChatThread.vue";
import NotificationsPage from "@/components/flockr-messaging/NotificationsPage.vue";

// ===== FLOCKER ADMIN =====
import AdminDashboard from "@/components/flockr-admin/AdminDashboard.vue";




// ===== FARM MANAGEMENT =====
import FarmDashboard from "@/components/flockr-farm/FarmDashboard.vue";
import FeedFormulations from "@/components/flockr-farm/FeedFormulations.vue";
import FeedingSchedules from "@/components/flockr-farm/FeedingSchedules.vue";
import VetConsultPay from "@/components/flockr-vet/VetConsultPay.vue";
import AnimalDetail from "@/components/flockr-farm/AnimalDetail.vue";
import DeliveryNotes from "@/components/flockr-farm/DeliveryNotes.vue";
import DeliveryNotePrint from "@/components/flockr-farm/DeliveryNotePrint.vue";
import Requisitions from "@/components/flockr-farm/Requisitions.vue";
import RequisitionPrint from "@/components/flockr-farm/RequisitionPrint.vue";
import SlaughterSheets from "@/components/flockr-farm/SlaughterSheets.vue";
import SlaughterSheetPrint from "@/components/flockr-farm/SlaughterSheetPrint.vue";
import PaymentCalculations from "@/components/flockr-farm/PaymentCalculations.vue";
import PaymentCalculationPrint from "@/components/flockr-farm/PaymentCalculationPrint.vue";
// import AnimalProfile from "@/components/flockr-farm/AnimalProfile.vue";
// import HealthRecords from "@/components/flockr-farm/HealthRecords.vue";

// ===== VET SERVICES =====
import VetDirectory from "@/components/flockr-vet/VetDirectory.vue";
import VetProfile from "@/components/flockr-vet/VetProfile.vue";
import VetDashboard from "@/components/flockr-vet/VetDashboard.vue";
import VetConsultation from "@/components/flockr-vet/VetConsultation.vue";
import AISymptomCheck from "@/components/flockr-vet/AISymptomCheck.vue";

// ===== TRANSPORT =====
import TransportDirectory from "@/components/flockr-transport/TransportDirectory.vue";
import TransporterDashboard from "@/components/flockr-transport/TransporterDashboard.vue";
import TransporterProfile from "@/components/flockr-transport/TransporterProfile.vue";
import TripDetail from "@/components/flockr-transport/TripDetail.vue";
import TransportPaymentPage from "@/components/flockr-transport/TransportPaymentPage.vue";
import PayLinkPage from "@/components/flockr-orders/PayLinkPage.vue";
import MyTransportBookings from "@/components/flockr-transport/MyTransportBookings.vue";

// ===== INSURANCE & FINANCE =====
import InsurancePage from "@/components/flockr-insurance/InsurancePage.vue";
import InsuranceProviderDashboard from "@/components/flockr-insurance/InsuranceProviderDashboard.vue";
import FinanceProviderDashboard from "@/components/flockr-insurance/FinanceProviderDashboard.vue";
// Corporate self-registration was removed — corporate accounts are now created by sellers only.
// Kept the import commented as a breadcrumb for the deprecation.
// import CorporateDashboard from "@/components/flockr-users/CorporateDashboard.vue";
import MyCorporateClients from "@/components/flockr-users/MyCorporateClients.vue";
import ReceivablesPage from "@/components/flockr-users/ReceivablesPage.vue";
import InvoiceDetailPage from "@/components/flockr-users/InvoiceDetailPage.vue";
import PublicInvoicePage from "@/components/flockr-users/PublicInvoicePage.vue";
import ClaimCorporateAccountPage from "@/components/flockr-users/ClaimCorporateAccountPage.vue";
import MyInvoicesPage from "@/components/flockr-users/MyInvoicesPage.vue";

// ===== MARKET INTELLIGENCE =====
import MarketIntelligence from "@/components/flockr-market/MarketIntelligence.vue";
import MarketReportDetail from "@/components/flockr-market/MarketReportDetail.vue";

// ===== COMMUNITY =====
import ForumPage from "@/components/flockr-community/ForumPage.vue";
import ForumTopicDetail from "@/components/flockr-community/ForumTopicDetail.vue";
import EventsPage from "@/components/flockr-community/EventsPage.vue";
import ProfilePage from "@/components/flockr-community/ProfilePage.vue";
import LearningHub from "@/components/flockr-community/LearningHub.vue";
import ArticleDetail from "@/components/flockr-community/ArticleDetail.vue";

// ===== PRODUCTS / AGRO-INPUTS =====
import AgroInputShop from "@/components/flockr-products/AgroInputShop.vue";
import ProductDetail from "@/components/flockr-products/ProductDetail.vue";
import MyProductsPage from "@/components/flockr-products/MyProductsPage.vue";
import AgroShopOnboarding from "@/components/flockr-products/AgroShopOnboarding.vue";
import AgroShopDashboard from "@/components/flockr-products/AgroShopDashboard.vue";
import CreateProductPage from "@/components/flockr-products/CreateProductPage.vue";
import SellerDeliverySettings from "@/components/flockr-products/SellerDeliverySettings.vue";

// ===== USERS & SETTINGS =====
import MyProfile from "@/components/flockr-users/MyProfile.vue";
import TermsPage from "@/components/flockr-legal/TermsPage.vue";


const routes = [



    // ===== PUBLIC ROUTES =====
    {
        path: "/",
        name: "landing",
        component: LandingPage,
        meta: { public: true }
    },
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: { public: true }
    },

    {
        path: "/register",
        name: "register",
        component: Register,
        meta: { public: true }
    },

    {
        path: "/reset-password",
        name: "reset-password",
        component: ResetPasswordPage,
        meta: { public: true }
    },

    // ===== DASHBOARD =====
    {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: { public: false }
    },

    // ===== DEVELOPER PORTAL =====
    { path: "/developers",           name: "developers",       component: DevelopersHome,     meta: { public: false } },
    { path: "/developers/apps/:id",  name: "developer-app",    component: DeveloperAppDetail, meta: { public: false } },
    { path: "/developers/docs",      name: "developers-docs",  component: DevelopersDocs,     meta: { public: true  } },

    // ===== MARKETPLACE - BROWSING & DISCOVERY =====
    {
        path: "/marketplace",
        name: "marketplace",
        component: MarketplaceHome,
        meta: { public: true }
    },

    {
        path: "/marketplace/search",
        name: "marketplace-search",
        component: ListingSearchResults,
        meta: { public: true }
    },

    {
        path: "/marketplace/listing/:id",
        name: "listing-detail",
        component: ListingDetail,
        meta: { public: true }
    },

    {
        path: "/marketplace/seller/:id",
        name: "seller-profile",
        component: SellerProfile,
        meta: { public: true }
    },

    {
        path: "/marketplace/category/:slug",
        name: "category-browse",
        component: CategoryBrowse,
        meta: { public: true }
    },
    { path: "/verification", name: "verification", component: SellerVerificationPage, meta: { public: false } },

    // ===== MARKETPLACE - SELLING / LISTING MANAGEMENT =====
    {
        path: "/sell/create",
        name: "create-listing",
        component: CreateListingPage,
        meta: { public: false }
    },
    {
        path: "/sell/edit/:id",
        name: "edit-listing",
        component: EditListingPage,
        meta: { public: false }
    },

    {
        path: "/my-listings",
        name: "my-listings",
        component: MyListingsPage,
        meta: { public: false }
    },

    {
        path: "/my-listings/performance/:id",
        name: "listing-performance",
        component: ListingPerformance,
        meta: { public: false }
    },

    // ===== MARKETPLACE - BUYER ACTIONS =====
    {
        path: "/marketplace/saved",
        name: "saved-listings",
        component: SavedListingsPage,
        meta: { public: false }
    },

    {
        path: "/marketplace/saved-searches",
        name: "saved-searches",
        component: SavedSearchesPage,
        meta: { public: false }
    },

    {
        path: "/marketplace/offer/:listingId",
        name: "make-offer",
        component: MakeOfferPage,
        meta: { public: false }
    },

    {
        path: "/my-offers",
        name: "my-offers",
        component: MyOffersPage,
        meta: { public: false }
    },

    // ===== MARKETPLACE - AGGREGATOR / BUY REQUESTS =====
    {
        path: "/marketplace/buy-requests",
        name: "buy-requests",
        component: BuyRequestsBoard,
        meta: { public: true }
    },

    {
        path: "/marketplace/buy-requests/create",
        name: "create-buy-request",
        component: CreateBuyRequest,
        meta: { public: false }
    },

    {
        path: "/marketplace/buy-requests/:id",
        name: "buy-request-detail",
        component: BuyRequestDetail,
        meta: { public: true }
    },

    {
        path: "/my-buy-requests",
        name: "my-buy-requests",
        component: MyBuyRequests,
        meta: { public: false }
    },

    {
        path: "/checkout/:offerId",
        name: "checkout",
        component: CheckoutPage,
        meta: { public: false }
    },

    {
        path: "/marketplace/suppliers",
        name: "supplier-network",
        component: SupplierNetworkPage,
        meta: { public: false }
    },

    // Cart
    { path: "/cart", name: "cart", component: Cart, meta: { public: false } },
    { path: "/cart/checkout", name: "cart-checkout", component: CartCheckout, meta: { public: false } },

    // Vet Services
    { path: "/vets", name: "vet-directory", component: VetDirectory, meta: { public: true } },
    { path: "/vet/:vetUserId", name: "vet-profile", component: VetProfile, meta: { public: true } },
    { path: "/vet/dashboard", name: "vet-dashboard", component: VetDashboard, meta: { public: false } },
    { path: "/vet/consultation/:consultationId", name: "vet-consultation", component: VetConsultation, meta: { public: false } },
    { path: "/vet/ai-check", name: "ai-symptom-check", component: AISymptomCheck, meta: { public: false } },

    // Transport & Logistics — literal paths first so they beat the :transporterId param match
    { path: "/transport", name: "transport-directory", component: TransportDirectory, meta: { public: true } },
    { path: "/transport/dashboard", name: "transporter-dashboard", component: TransporterDashboard, meta: { public: false } },
    { path: "/transport/trip/:id", name: "trip-detail", component: TripDetail, meta: { public: false } },
    { path: "/transport/pay/:ref", name: "transport-pay", component: TransportPaymentPage, meta: { public: true } },
    { path: "/pay/:ref", name: "pay-link", component: PayLinkPage, meta: { public: true } },
    { path: "/my-transports", name: "my-transports", component: MyTransportBookings, meta: { public: false } },
    { path: "/transport/:transporterId", name: "transporter-profile", component: TransporterProfile, meta: { public: true } },

    // Insurance & Finance
    { path: "/insurance", name: "insurance", component: InsurancePage, meta: { public: false } },
    { path: "/insurance/provider", name: "insurance-provider", component: InsuranceProviderDashboard, meta: { public: false } },
    { path: "/finance", name: "finance", component: InsurancePage, meta: { public: false } },
    { path: "/finance/provider", name: "finance-provider", component: FinanceProviderDashboard, meta: { public: false } },
    // ---------- Corporate client invoicing (seller-side whitelist + invoice flow) ----------
    { path: "/my-corporate-clients", name: "my-corporate-clients", component: MyCorporateClients, meta: { public: false } },
    { path: "/receivables", name: "receivables", component: ReceivablesPage, meta: { public: false } },
    { path: "/receivables/invoice/:id", name: "invoice-detail", component: InvoiceDetailPage, meta: { public: false } },
    // Alias: notifications + emails emit "/invoices/:id" — keep this routable so
    // older links don't dead-end on a white page. Internally uses the same component.
    { path: "/invoices/:id", name: "invoice-detail-alias", component: InvoiceDetailPage, meta: { public: false } },
    { path: "/my-invoices", name: "my-invoices", component: MyInvoicesPage, meta: { public: false } },
    // Public tokenised invoice link (no login required — for corporates who haven't claimed)
    { path: "/invoice/:token", name: "public-invoice", component: PublicInvoicePage, meta: { public: true } },
    { path: "/claim/:token", name: "claim-corporate", component: ClaimCorporateAccountPage, meta: { public: true } },

    // Market Intelligence — public so non-logged-in users can browse prices + reports
    { path: "/market", name: "market-intel", component: MarketIntelligence, meta: { public: true } },
    { path: "/market/report/:idOrSlug", name: "market-report", component: MarketReportDetail, meta: { public: true } },

    // Agro-Input Shop — public catalogue, login-gated checkout via the cart
    { path: "/shop", name: "agro-shop", component: AgroInputShop, meta: { public: true } },
    { path: "/shop/product/:idOrSlug", name: "product-detail", component: ProductDetail, meta: { public: true } },

    // Agro-Input Shop — seller side
    { path: "/sell/dashboard", name: "agro-shop-dashboard", component: AgroShopDashboard, meta: { public: false } },
    { path: "/sell/shop", name: "agro-shop-onboarding", component: AgroShopOnboarding, meta: { public: false } },
    { path: "/sell/products", name: "my-products", component: MyProductsPage, meta: { public: false } },
    { path: "/sell/product/create", name: "product-create", component: CreateProductPage, meta: { public: false } },
    { path: "/sell/product/edit/:id", name: "product-edit", component: CreateProductPage, meta: { public: false } },
    { path: "/sell/delivery", name: "seller-delivery", component: SellerDeliverySettings, meta: { public: false } },

    // Community & Learning Hub — public reading; posting requires login (handled in-page)
    { path: "/learn", name: "learning-hub", component: LearningHub, meta: { public: true } },
    { path: "/learn/:idOrSlug", name: "article-detail", component: ArticleDetail, meta: { public: true } },
    { path: "/forum", name: "forum", component: ForumPage, meta: { public: true } },
    { path: "/forum/:id", name: "forum-topic", component: ForumTopicDetail, meta: { public: true } },
    { path: "/events", name: "events", component: EventsPage, meta: { public: true } },
    { path: "/events/:id", name: "event-detail", component: EventsPage, meta: { public: true } },
    { path: "/u/:id", name: "user-profile", component: ProfilePage, meta: { public: true } },

    // Orders & Transactions
    { path: "/orders", name: "orders", component: OrdersPage, meta: { public: false } },
    { path: "/orders/:id", name: "order-detail", component: OrderDetail, meta: { public: false } },
    { path: "/escrow", name: "escrow-dashboard", component: EscrowDashboard, meta: { public: false } },
    { path: "/me", name: "my-profile", component: MyProfile, meta: { public: false } },
    { path: "/my-referrals", name: "my-referrals", component: MyReferrals, meta: { public: false } },
    // Bills (Send Bill / Proforma Invoice) — Alex 2026-07-21
    { path: "/sell/bills/new", name: "create-bill", component: CreateBill, meta: { public: false } },
    { path: "/sell/bills", name: "my-bills", component: MyBills, meta: { public: false } },
    { path: "/bills", name: "bills-inbox", component: BillsInbox, meta: { public: false } },
    { path: "/bills/:token", name: "bill-view", component: BillView, meta: { public: true } },
    // Credit Passport — Alex 2026-07-23
    { path: "/credit-passport", name: "credit-passport", component: CreditPassport, meta: { public: false } },
    { path: "/credit-passport/statement", name: "credit-statement", component: CreditStatementPrint, meta: { public: false } },
    { path: "/credit-passport/view/:token", name: "credit-passport-public", component: PublicCreditPassport, meta: { public: true } },
    { path: "/terms", name: "terms", component: TermsPage, meta: { public: true } },
    { path: "/wallet", name: "wallet", component: WalletPage, meta: { public: false } },
    { path: "/messages", name: "messages", component: MessagesInbox, meta: { public: false } },
    { path: "/messages/:id", name: "chat-thread", component: ChatThread, meta: { public: false } },
    { path: "/notifications", name: "notifications", component: NotificationsPage, meta: { public: false } },
    { path: '/dispute/:id', component: DisputePage },
    { path: '/disputes', component: DisputePage },
    { path: '/reviews', component: ReviewsPage},

    //FLOCKER ADMIN — locked behind admin/super_admin role.
    // Server-side assertAdmin() in index.php is the real defence; this guard is the UX layer.
    {
        path: "/admin",
        name: "admin",
        component: AdminDashboard,
        meta: { requiresAdmin: true }
    },



    // Farm Management
    {
        path: '/farm',
        name: 'FarmDashboard',
        component: FarmDashboard,
        meta: { requiresAuth: true }
    },
    {
        // Vaccination calendar deep-link from notification reminders.
        // FarmDashboard reads the path suffix and pre-selects the 'vacccal' tab.
        path: '/farm/:farmId/vaccination-calendar',
        name: 'FarmVaccinationCalendar',
        component: FarmDashboard,
        meta: { requiresAuth: true }
    },
    {
        path: '/farm/animal/:id',
        name: 'AnimalDetail',
        component: AnimalDetail,
        meta: { requiresAuth: true }
    },
    {
        path: '/farm/:farmId/delivery-notes',
        name: 'DeliveryNotes',
        component: DeliveryNotes,
        meta: { requiresAuth: true }
    },
    {
        path: '/delivery-note/:id/print',
        name: 'DeliveryNotePrint',
        component: DeliveryNotePrint,
        meta: { requiresAuth: false }
    },
    {
        path: '/farm/:farmId/requisitions',
        name: 'Requisitions',
        component: Requisitions,
        meta: { requiresAuth: true }
    },
    {
        path: '/requisition/:id/print',
        name: 'RequisitionPrint',
        component: RequisitionPrint,
        meta: { requiresAuth: false }
    },
    {
        path: '/farm/:farmId/slaughter-sheets',
        name: 'SlaughterSheets',
        component: SlaughterSheets,
        meta: { requiresAuth: true }
    },
    {
        path: '/slaughter-sheet/:id/print',
        name: 'SlaughterSheetPrint',
        component: SlaughterSheetPrint,
        meta: { requiresAuth: false }
    },
    {
        path: '/farm/:farmId/payment-calculations',
        name: 'PaymentCalculations',
        component: PaymentCalculations,
        meta: { requiresAuth: true }
    },
    {
        path: '/payment-calc/:id/print',
        name: 'PaymentCalculationPrint',
        component: PaymentCalculationPrint,
        meta: { requiresAuth: false }
    },
    {
        path: '/farm/feed-formulations',
        name: 'FeedFormulations',
        component: FeedFormulations,
        meta: { requiresAuth: true }
    },
    {
        path: '/farm/feeding-schedules',
        name: 'FeedingSchedules',
        component: FeedingSchedules,
        meta: { requiresAuth: true }
    },
    {
        path: '/pay/consult/:ref',
        name: 'VetConsultPay',
        component: VetConsultPay,
        meta: { public: true, requiresAuth: false }
    },


];

const router = createRouter({
    history: createWebHistory(),
    routes,
    // Scroll to top on route change so long marketplace lists don't retain scroll.
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition;
        if (to.hash)       return { el: to.hash };
        return { top: 0 };
    }
});

// Per-page SEO meta (Alex 2026-07-22). Sets a unique title + description +
// canonical + open-graph tags on every route change so Google indexes each
// URL with distinct metadata. Individual components can override the auto-
// generated meta by calling `this.$updateHead({ title, description, image })`.
router.afterEach((to) => {
    if (typeof document === 'undefined') return;
    const brand = 'Flockr — Africa\'s Livestock Marketplace';
    const defaults = {
        title:       brand,
        description: 'Buy and sell livestock across Africa. Farm management, vet consultations, agro-inputs, insurance and market intelligence — all in one platform.',
        image:       'https://flockr.africa/assets/images/flockr_logo.png',
    };
    // Route-specific hints keyed off the path prefix. Deeper overrides come from
    // page-level updateHead() calls in the mounted() hook of the component.
    const routeHints = {
        '/marketplace': { title: 'Livestock Marketplace · Africa | Flockr', description: 'Browse thousands of verified livestock listings — cattle, goats, sheep, chickens, camels, pigs. Buy directly from farmers with escrow protection.' },
        '/vets':        { title: 'Find a Veterinarian · Online & In-Person | Flockr', description: 'Book qualified veterinarians for farm visits, video consultations, and 24/7 emergency care across East Africa.' },
        '/market':      { title: 'Livestock Market Prices & Intelligence | Flockr', description: 'Live cattle, goat, sheep and poultry prices across counties. Expert insights, trend analysis, and weekly market reports.' },
        '/shop':        { title: 'Agro-Input Shop · Feeds, Vet Meds, Equipment | Flockr', description: 'Buy dairy feeds, poultry feeds, vaccines, dewormers, milking equipment and farm supplies from verified sellers.' },
        '/learn':       { title: 'Farming Knowledge Hub · Learn & Grow | Flockr', description: 'Free articles on livestock farming, animal health, breeding, feed formulation, and market economics across Africa.' },
        '/forum':       { title: 'Farmer Community & Forum | Flockr', description: 'Ask questions, share tips, and learn from thousands of farmers across Africa.' },
        '/marketplace/buy-requests': { title: 'Buy Requests · Post What You Need | Flockr', description: 'Post what livestock you\'re looking for and let sellers come to you. Free to post, escrow-protected transactions.' },
        '/insurance':   { title: 'Livestock Insurance · Protect Your Herd | Flockr', description: 'Insure cattle, goats, poultry and other livestock through licensed underwriters. Fast claims, clear terms.' },
        '/register':    { title: 'Sign up for Flockr — free', description: 'Create a free Flockr account and start buying or selling livestock, managing your farm, and connecting with vets.' },
        '/login':       { title: 'Sign in to Flockr', description: 'Log in to your Flockr account.' },
        '/terms':       { title: 'Terms of Service & Privacy Policy | Flockr', description: 'Full terms of service and privacy policy for Flockr, the pan-African livestock marketplace.' },
        '/credit-passport':      { title: 'Flockr Credit Passport · Build Your Farming Credit Score', description: 'Your on-platform transactions, KYC, farm records and community reputation build a portable Credit Passport that unlocks financing from MFIs, SACCOs and banks.' },
        '/credit-passport/view': { title: 'Flockr Credit Passport · Verified Livestock Farmer Credit Profile', description: 'A live, verified credit profile for a Flockr farmer — recognised by lending partners across Africa.' },
        '/':            { title: brand + ' · Buy & Sell Livestock, Farm Management, Vet Services', description: defaults.description },
    };
    // Pick the longest-prefix match so /marketplace/listing/:id inherits /marketplace hints
    let hint = defaults;
    let bestPrefix = '';
    Object.keys(routeHints).forEach(prefix => {
        if (to.path === prefix || to.path.indexOf(prefix + '/') === 0) {
            if (prefix.length > bestPrefix.length) { bestPrefix = prefix; hint = Object.assign({}, defaults, routeHints[prefix]); }
        }
    });
    if (!bestPrefix) hint = defaults;

    document.title = hint.title;
    // GA4 page_view (Alex 2026-07-23). Emitted from router.afterEach because
    // SPA route changes aren't automatic pageviews in gtag's default config.
    if (typeof window !== 'undefined' && typeof window.gtag === 'function' && window.__flockrGa4Id) {
      try {
        window.gtag('event', 'page_view', {
          page_title: hint.title,
          page_location: window.location.href,
          page_path: to.fullPath
        });
      } catch(e){ /* analytics is best-effort */ }
    }
    setOrCreateMeta('name', 'description',       hint.description);
    setOrCreateMeta('property', 'og:title',      hint.title);
    setOrCreateMeta('property', 'og:description',hint.description);
    setOrCreateMeta('property', 'og:image',      hint.image);
    setOrCreateMeta('property', 'og:url',        window.location.href);
    setOrCreateMeta('property', 'og:site_name',  'Flockr');
    setOrCreateMeta('property', 'og:type',       'website');
    setOrCreateMeta('name', 'twitter:card',      'summary_large_image');
    setOrCreateMeta('name', 'twitter:title',     hint.title);
    setOrCreateMeta('name', 'twitter:description', hint.description);
    setOrCreateMeta('name', 'twitter:image',     hint.image);
    // Canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = window.location.href;
});
function setOrCreateMeta(attr, name, value) {
    if (typeof document === 'undefined' || !value) return;
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
    el.setAttribute('content', value);
}


let userActivityTimer;

function clientHasAdminRole() {
    var roles = [];
    try { roles = JSON.parse(sessionStorage.getItem("userRoles") || "[]"); } catch (e) { /* fall through */ }
    return roles.indexOf("admin") > -1 || roles.indexOf("super_admin") > -1;
}

// Re-fetch the user's roles + admin module permissions from the server. Keeps
// sessionStorage fresh in case roles were changed in another tab (or by another
// super_admin) during this session.
async function refreshRolesFromServer() {
    var userId = sessionStorage.getItem("userId");
    if (!userId) return null;
    try {
        var r = await executeJson({ function: "getMyRoles", userId: userId }, flocker);
        if (r && r.data && r.data.success) {
            var d = r.data.data || {};
            var roles = d.roles || [];
            sessionStorage.setItem("userRoles", JSON.stringify(roles));
            sessionStorage.setItem("adminModules", JSON.stringify(d.adminModules || []));
            return d;
        }
    } catch (e) { /* offline / network — fall back to cached */ }
    return null;
}

router.beforeEach(async (to, from, next) => {
    clearTimeout(userActivityTimer);

    // Public routes: free pass
    if (to.meta.public) { next(); return; }

    // Login required — carry the intended destination so deep links from
    // notification emails (e.g. transporter trip links) survive the login step.
    if (!sessionStorage.getItem("isLoggedIn")) {
        next({ path: "/login", query: { redirect: to.fullPath } });
        return;
    }

    // Admin gate: client check first (fast), server reverify if cache is empty/stale
    if (to.meta.requiresAdmin) {
        if (!clientHasAdminRole()) {
            var fresh = await refreshRolesFromServer();
            if (!fresh || !fresh.isAdmin) {
                alert("This area is for Flockr admins only.");
                next("/dashboard");
                return;
            }
        }
    }

    next();

    userActivityTimer = setTimeout(() => {
        sessionStorage.removeItem("isLoggedIn");
        router.push("/login");
    }, 10 * 60 * 1000);
});

function handleUserActivity() {
    // Only track activity if user is logged in
    if (!sessionStorage.getItem("isLoggedIn")) return;

    clearTimeout(userActivityTimer);
    userActivityTimer = setTimeout(() => {
        sessionStorage.removeItem("isLoggedIn");
        router.push("/login");
    }, 10 * 60 * 1000);
}

document.addEventListener("mousemove", handleUserActivity);
document.addEventListener("keypress", handleUserActivity);

export default router;